import { NotificationInline } from '../../../Notification'
import { useDocFlowSendingContext } from '../../DocFlow.hooks'
import {
  isDocFlowSendingWidgetStatusCompleted,
  isDocFlowSendingWidgetStatusNotStarted,
  isDocFlowSendingWidgetStatusStartedWithError,
} from '../../DocFlowSending'
import { DocFlowWidgetForm } from '../../DocFlowWidgetForm'

import * as styles from './DocFlowSendingWidgetContent.module.css'

function DocFlowSendingWidgetContent({
  actionsProps,
  isError,
  notifications,
  widgetStatusFieldName,
  ...restProps
}) {
  const { isProcessDataLoading, processData } = useDocFlowSendingContext()

  const widgetDone = isDocFlowSendingWidgetStatusCompleted(
    processData?.[widgetStatusFieldName]
  )

  const hasError = isDocFlowSendingWidgetStatusStartedWithError(
    processData?.[widgetStatusFieldName]
  )

  const notStarted = isDocFlowSendingWidgetStatusNotStarted(
    processData?.[widgetStatusFieldName]
  )

  return (
    <DocFlowWidgetForm
      {...restProps}
      actionsProps={{
        ...actionsProps,
        disabled: actionsProps?.disabled || isProcessDataLoading,
      }}
      done={widgetDone && !isError}
      hasError={hasError || isError}
      unvisited={notStarted}
    >
      {notifications.map(item => (
        <NotificationInline
          {...item}
          className={styles.notification}
          key={item.text}
        />
      ))}
    </DocFlowWidgetForm>
  )
}

export default DocFlowSendingWidgetContent
